define(["require", "exports", "jquery", "knockout", "log", "../../utils/urls", "../../utils/tools", "../../models/UserContext", "../../shared/dataLogs", "./cpActions", "./customerUserActions", "../../models/CPCustomerProfileModel"], function (require, exports, $, ko, log, urls_1, tools, UserContext, DataLogs, CPActions, CPCustomerUserActions, CPCustomerProfileModel) {
    "use strict";
    var CPCustomerProfileDetails = /** @class */ (function () {
        function CPCustomerProfileDetails() {
            this.userCanViewUser = ko.observable(UserContext.hasAccess("Admin,CPCustomerUsers.View,CPCustomerUsers.Edit,CPCustomerUsers.Delete"));
            this.userCanAddUser = ko.observable(UserContext.hasAccess("Admin,CPCustomerUsers.Edit,CPCustomerUsers.Delete"));
            this.filterByAny = ko.observable("");
            this.editModel = ko.observable(new CPCustomerProfileModel());
        }
        CPCustomerProfileDetails.prototype.init = function (id) {
            var self = this;
            $("#page-title").text("CP Customer Profile Details");
            var getModelCall = self.getCPCustomerProfileById(id);
            $.when(getModelCall).done(function () {
                self.cpActions = new CPActions();
                self.cpActions.afterSuccess = function () {
                    self.getCPCustomerProfileById(id);
                };
                if (self.userCanViewUser()) {
                    self.cpCustomerUserActions = new CPCustomerUserActions(id, function (service) {
                        service.initGridOnShow();
                    });
                    self.cpCustomerUserActions.afterSuccess = function () {
                        self.cpCustomerUserActions.customerUserTable.refresh();
                    };
                }
                ko.applyBindings(self, document.getElementById("main-container"));
                $("#contextLoader").hide();
                $("#mainContext").show();
            });
        };
        CPCustomerProfileDetails.prototype.getCPCustomerProfileById = function (id) {
            var self = this;
            return tools.ajaxGet({
                url: "/CPCustomerProfiles/GetCPCustomerProfileById",
                data: { id: id },
                success: function (result) {
                    if (result.Success) {
                        self.editModel(new CPCustomerProfileModel(result.Data));
                    }
                }
            });
        };
        CPCustomerProfileDetails.prototype.addCustomerUser = function () {
            var self = this;
            self.cpCustomerUserActions.editCustomerUser();
        };
        CPCustomerProfileDetails.prototype.addCPCustomerProfile = function () {
            var self = this;
            self.cpActions.editCPCustomerProfile();
        };
        CPCustomerProfileDetails.prototype.editCPCustomerProfile = function () {
            var self = this;
            self.cpActions.editCPCustomerProfile(self.editModel().Id());
        };
        CPCustomerProfileDetails.prototype.editCPCustomerProfileModules = function () {
            var self = this;
            self.cpActions.editCustomModules(self.editModel().Id());
        };
        CPCustomerProfileDetails.prototype.showLogs = function () {
            var self = this;
            if (UserContext.hasAccess("Admin")) {
                var dataLogs = new DataLogs("CPCustomerProfile", self.editModel().Id());
                dataLogs.open("CP Customer Profile logs");
            }
        };
        return CPCustomerProfileDetails;
    }());
    setTimeout(function () {
        if (urls_1.urls.startsWith("/CPCustomerProfiles/Details")) {
            var id_1 = urls_1.urls.getIdFromQueryString();
            if (id_1 <= 0) {
                id_1 = urls_1.urls.getIdFromUrl();
            }
            log.log("Initialize CPCustomerProfile details");
            $(function () {
                (new CPCustomerProfileDetails()).init(id_1 + '');
            });
        }
    }, 0);
    return CPCustomerProfileDetails;
});
//# sourceMappingURL=customerProfileDetails.js.map


//////////////////
// WEBPACK FOOTER
// ./build/areas/customerPortalAdmin/customerProfileDetails.js
// module id = 310
// module chunks = 2